import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在讨论什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
          {topicsData.map((topic, index) => (
            <span
              key={index}
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200 rounded-full cursor-pointer hover:border-primary-200 hover:bg-primary-50/50 transition-colors"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.label}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}